import {ClinType} from "@app/shared";

export class ContractClinFunding {
  id: number;
  version: number;
  name: string;
  description?: string;
  contractModId?: number;
  // statusId: number;
  feeType: string;
  priceType: string;
  fundingType: string;
  percentFunded?: number;
  totalCeiling?: number;
  fundedCeiling?: number;
  unfundedCeiling?: number;
  actualCeiling?: number;
  remainingCeiling?: number;
  contractClinId: number;
  modNumber?: string;
}

// Front end data structures cumulative OptionFunding Variables
export class OptionCumulativeFunding {
  awardedOptionFunding: number;
  fundedOptionFunding: number;
  cumulativeSumAwarded: number;
  cumulativeSumFunded: number;
  clinType: ClinType;
}

export class FundingValidationResponse {
  canClinFundingBeAdded: boolean;
  validationMessage: string;
}